<template>
  <div class="error-view">
    <div class="error-backdrop">
      <div class="message-card">
        <header class="card-header">给我们留言</header>
        <div class="card-body">
          <p class="intro-text">{{ introText }}</p>

          <div class="field">
            <label class="field-label"
              >电话<span class="required">*</span></label
            >
            <input
              v-model.trim="form.phone"
              type="tel"
              class="field-input"
              placeholder="请输入电话"
              autocomplete="tel"
            />
          </div>

          <div class="field">
            <label class="field-label"
              >{{ secondFieldLabel }}<span class="required">*</span></label
            >
            <input
              v-model.trim="form.extra"
              type="text"
              class="field-input"
              :placeholder="'请输入' + secondFieldLabel"
            />
          </div>

          <div class="upload-block">
            <div class="upload-grid">
              <div
                v-for="(item, idx) in imageFiles"
                :key="item.id"
                class="upload-thumb"
              >
                <img :src="item.previewUrl" alt="" />
                <button
                  type="button"
                  class="thumb-remove"
                  aria-label="删除"
                  @click="removeImage(idx)"
                >
                  ×
                </button>
              </div>
              <button
                v-if="imageFiles.length < maxImages"
                type="button"
                class="upload-add"
                @click="$refs.fileInput.click()"
              >
                <span class="upload-plus">+</span>
                <span class="upload-add-text">上传图片</span>
              </button>
            </div>
            <input
              ref="fileInput"
              type="file"
              class="visually-hidden"
              accept=".jpg,.jpeg,.png,.gif,.svg,image/jpeg,image/png,image/gif,image/svg+xml"
              multiple
              @change="onFileChange"
            />
            <p class="upload-hint">
              *
              支持 jpg、png、gif、svg
              格式的图片，可上传 5 张，单张最大 5M
            </p>
          </div>

          <el-button
            type="primary"
            native-type="button"
            class="submit-btn-el"
            :loading="submitting"
            @click="onSubmit"
          >
            提交
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const MAX_IMAGES = 5;
const MAX_SIZE = 5 * 1024 * 1024;
const ACCEPT_EXT = /\.(jpe?g|png|gif|svg)$/i;

export default {
  name: "ErrorView",
  data() {
    return {
      form: {
        phone: "",
        extra: ""
      },
      imageFiles: [],
      maxImages: MAX_IMAGES,
      submitting: false,
      submitTimer: null
    };
  },
  computed: {
    introText() {
      return (
        this.$route.query.intro ||
        "您好，很抱歉我们暂时无法为您提供服务，如需帮助，请留言，我们将尽快联系并解决您的问题。"
      );
    },
    secondFieldLabel() {
      return this.$route.query.secondLabel || "留言";
    }
  },
  mounted() {
    const q = this.$route.query;
    if (q.phone != null && q.phone !== "") this.form.phone = String(q.phone);
    if (q.extra != null && q.extra !== "") this.form.extra = String(q.extra);
  },
  beforeDestroy() {
    if (this.submitTimer) {
      clearTimeout(this.submitTimer);
      this.submitTimer = null;
    }
    this.submitting = false;
    this.revokePreviews();
  },
  methods: {
    resetForm() {
      this.form.phone = "";
      this.form.extra = "";
      this.revokePreviews();
      this.imageFiles = [];
    },
    revokePreviews() {
      this.imageFiles.forEach((f) => {
        if (f.previewUrl) URL.revokeObjectURL(f.previewUrl);
      });
    },
    removeImage(index) {
      const [removed] = this.imageFiles.splice(index, 1);
      if (removed && removed.previewUrl) {
        URL.revokeObjectURL(removed.previewUrl);
      }
    },
    onFileChange(e) {
      const input = e.target;
      const files = Array.from(input.files || []);
      input.value = "";

      for (const file of files) {
        if (this.imageFiles.length >= MAX_IMAGES) {
          this.$message.warning(`最多上传 ${MAX_IMAGES} 张图片`);
          break;
        }
        if (file.size > MAX_SIZE) {
          this.$message.warning("单张图片不能超过 5M");
          continue;
        }
        const name = file.name || "";
        if (!ACCEPT_EXT.test(name) && file.type) {
          const okType = /^(image\/(jpeg|png|gif|svg\+xml))$/i.test(file.type);
          if (!okType) {
            this.$message.warning("仅支持 jpg、png、gif、svg 格式");
            continue;
          }
        } else if (!ACCEPT_EXT.test(name)) {
          this.$message.warning("仅支持 jpg、png、gif、svg 格式");
          continue;
        }
        this.imageFiles.push({
          id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
          file,
          previewUrl: URL.createObjectURL(file)
        });
      }
    },
    onSubmit() {
      if (this.submitting) return;
      if (!this.form.phone) {
        this.$message.warning("请填写电话");
        return;
      }
      if (!this.form.extra) {
        this.$message.warning(`请填写${this.secondFieldLabel}`);
        return;
      }
      this.submitting = true;
      this.submitTimer = setTimeout(() => {
        this.submitTimer = null;
        this.$message.success("提交成功");
        this.resetForm();
        this.submitting = false;
      }, 2000);
    }
  }
};
</script>

<style lang="scss" scoped>
$error-view-blue: #3b82f6;
$error-view-blue-hover: #2563eb;
$error-view-bg: rgba(30, 30, 30, 0.55);

.error-view {
  position: fixed;
  inset: 0;
  z-index: 2000;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.error-backdrop {
  min-height: 100%;
  width: 100%;
  background: $error-view-bg;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
  overflow-y: auto;
}

.message-card {
  width: 100%;
  max-width: 560px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.card-header {
  background: $error-view-blue;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  padding: 14px 20px;
  letter-spacing: 0.02em;
}

.card-body {
  padding: 20px 20px 24px;
}

.intro-text {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.65;
  color: #4b5563;
}

.field {
  margin-bottom: 18px;
}

.field-label {
  display: block;
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

.field-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  font-size: 15px;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #fff;
  outline: none;
  transition: border-color 0.15s ease;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    border-color: $error-view-blue;
  }
}

.upload-block {
  margin-bottom: 24px;
}

.upload-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.upload-add,
.upload-thumb {
  width: 96px;
  height: 96px;
  border-radius: 4px;
  flex-shrink: 0;
}

.upload-add {
  border: 1px dashed #d1d5db;
  background: #f9fafb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6b7280;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f3f4f6;
    border-color: #9ca3af;
  }
}

.upload-plus {
  font-size: 28px;
  line-height: 1;
  font-weight: 300;
  margin-bottom: 4px;
}

.upload-add-text {
  font-size: 12px;
}

.upload-thumb {
  position: relative;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  background: #f3f4f6;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.thumb-remove {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(0, 0, 0, 0.72);
  }
}

.upload-hint {
  margin: 10px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #9ca3af;
}

.submit-btn-el {
  width: 100%;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 6px;
  background-color: $error-view-blue;
  border-color: $error-view-blue;

  &:hover,
  &:focus {
    background-color: $error-view-blue-hover;
    border-color: $error-view-blue-hover;
  }
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 480px) {
  .error-backdrop {
    padding: 0;
    align-items: stretch;
    justify-content: stretch;
    min-height: 100vh;
    min-height: 100dvh;
    background: #fff;
  }

  .message-card {
    max-width: none;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    border-radius: 0;
    box-shadow: none;
    display: flex;
    flex-direction: column;
  }

  .card-body {
    flex: 1;
    padding: 16px 16px max(20px, env(safe-area-inset-bottom));
  }

  .card-header {
    font-size: 17px;
    padding: 12px 16px;
    padding-top: max(12px, env(safe-area-inset-top));
  }

  .upload-add,
  .upload-thumb {
    width: 88px;
    height: 88px;
  }
}
</style>
